import React from 'react'
import { portfolio1Image, portfolio2Image, portfolio3Image, portfolio4Image, portfolio5Image, portfolio6Image } from '../data/constant'
import { Link } from 'react-router-dom'

function Footer() {
    return (
        <div className="container-fluid bg-primary text-light footer wow fadeIn" data-wow-delay="0.1s">
            <div className="container py-5 px-lg-5">
                <div className="row g-5">
                    <div className="col-md-6 col-lg-3">
                        <p className="section-title text-white h5 mb-4">Address<span /></p>
                        <p><i className="fa fa-map-marker-alt  me-3" />119 Rise on plaza, Sarthana Jakatnaka, Surat,  Gujarat 395008</p>
                        <p><i className="fa fa-phone-alt me-3" />+91 982580-5271</p>
                        <p><i className="fa fa-envelope me-3" /> Write to us   dgmtechsolution@gmail.com</p>
                        <div className="d-flex pt-2">
                            <a className="btn btn-outline-light btn-social" href="#"><i className="fab fa-twitter" /></a>
                            <a className="btn btn-outline-light btn-social" href="#"><i className="fab fa-facebook-f" /></a>
                            <a className="btn btn-outline-light btn-social" href="#"><i className="fab fa-instagram" /></a>
                            <a className="btn btn-outline-light btn-social" href="#"><i className="fab fa-linkedin-in" /></a>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <p className="section-title text-white h5 mb-4">Quick Link<span /></p>
                        <Link className="btn btn-link" to='/about'>About Us</Link>
                        <Link className="btn btn-link" to='/contact'>Contact Us</Link>
                        <Link className="btn btn-link" to='/'>Privacy Policy</Link>
                        <Link className="btn btn-link" to='/'>Terms &amp; Condition</Link>
                        <Link className="btn btn-link" to='/'>Career</Link>
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <p className="section-title text-white h5 mb-4">Gallery<span /></p>
                        <div className="row g-2">
                            <div className="col-4">
                                <img className="img-fluid" src={portfolio1Image} alt="Image" />
                            </div>
                            <div className="col-4">
                                <img className="img-fluid" src={portfolio2Image} alt="Image" />
                            </div>
                            <div className="col-4">
                                <img className="img-fluid" src={portfolio3Image} alt="Image" />
                            </div>
                            <div className="col-4">
                                <img className="img-fluid" src={portfolio4Image} alt="Image" />
                            </div>
                            <div className="col-4">
                                <img className="img-fluid" src={portfolio5Image} alt="Image" />
                            </div>
                            <div className="col-4">
                                <img className="img-fluid" src={portfolio6Image} alt="Image" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <p className="section-title text-white h5 mb-4">Newsletter<span /></p>
                        <p>Stay ahead with DGM&apos;s newsletter for the latest tech trends and expert insights, delivered to your inbox.</p>
                        <div className="position-relative w-100 mt-3">
                            <input className="form-control border-0 rounded-pill w-100 ps-4 pe-5" type="text" placeholder="Your Email" style={{ height: 48 }} />
                            <button type="button" className="btn shadow-none position-absolute top-0 end-0 mt-1 me-2"><i className="fa fa-paper-plane text-primary fs-4" /></button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container px-lg-5">
                <div className="copyright">
                    <div className="row">
                        <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                            © <Link className="border-bottom" to='/home'>2024 DGM</Link>, All Right Reserved.
                     
                        </div>
                        <div className="col-md-6 text-center text-md-end">
                            <div className="footer-menu">
                                <Link to="/home">Home</Link>
                                <Link to="/">Cookies</Link>
                                <Link to="/">Help</Link>
                                <Link to="/">FQAs</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer